import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Dataset } from '@ca/core/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ca-modal-confirm',
    templateUrl: './modal-confirm.component.html',
    styleUrls: ['./modal-confirm.component.scss'],
})
export class ModalConfirmComponent {
    @Input() title = 'Confirmation';
    @Input() message = 'Are you sure?';
    @Input() confirmText = 'Confirm';
    @Input() cancelText = 'Cancel';
    @Input() customText = 'Custom';
    @Input() showCancel = true;
    @Input() showClose = true;
    @Input() warningMessage? = '';
    @Input() showCustom = false;
    @Input() customCssClassConfirmBtn = 'btn-primary';
    @Input() customCssClass?: string;
    @Input() currentDataset?: Dataset;
    @Input() buttonsContainerCustomCssClass?: string;
    @Input() showInput = false;
    @Input() inputPlaceholder?: string;
    @Input() isTitleCentered?: boolean;
    @Input() isBodyCentered?: boolean;
    @Input() isAtDatasetList?: boolean;

    @Output() onConfirm = new EventEmitter<string>();
    @Output() onCancel = new EventEmitter<string>();

    inputText: string = '';

    constructor(private activeModal: NgbActiveModal) {}

    cancel(): void {
        this.activeModal.dismiss('Canceled');
    }

    ok(): void {
        const dataToPass: string = this.showInput === true ? this.inputText : 'OK';
        this.activeModal.close(dataToPass);
    }

    isOkButtonDisabled(): boolean {
        return this.showInput ? this.inputText === '' : false;
    }

    customAction(): void {
        this.activeModal.close('custom');
    }
}
